export const AUTH_TOKEN = 'auth_token'
export const INFO_USER = 'info_user'
export const ROLE = 'role'
export const BINDING_ROLES = 'binding_roles'
export const BINDING_ROLES_CONTABILITA = 'binding_roles_contabilita'
export const BINDING_ROLES_COMPANY_STORES = 'binding_roles_company_stores'
export const FOTO_PROFILO = 'foto_profilo'
export const VERSION_APP = 'version_app';
export const CENTRO_IN_USO = 'centro';
export const AZIENDA_IN_USO = 'azienda_in_uso';
export const INIZIALIZZA_ROTTE = 'inizializza_rotte';
export const INIZIALIZZA_LOAD_AZIENDA = 'inizializza_load_azienda';

//redux: PAZIENTI
export const PAZIENTI_VALUE = 'pazienti'
export const PAZIENTI_MAP_VALUE = 'pazientiMap'
export const PAZIENTI_LOADED = 'pazienti_loaded'
export const PAZIENTI_ERROR = 'pazienti_error'

//redux: PUNTI VENDITA
export const PUNTI_VENDITA_VALUE = 'punti_vendita'
export const PUNTI_VENDITA_LOADED = 'punti_vendita_loaded'
export const PUNTI_VENDITA_ERROR = 'punti_vendita_error'

//redux: PROVENIENZE
export const PROVENIENZE_VALUE = 'provenienze'
export const PROVENIENZE_LOADED = 'provenienze_loaded'
export const PROVENIENZE_ERROR = 'provenienze_error'

//redux: PAZIENTI STATI E TIPI
export const PAZIENTI_STATI_TIPI_VALUE = 'pazienti_stati_tipi'
export const PAZIENTI_STATI_TIPI_LOADED = 'pazienti_stati_tipi_loaded'
export const PAZIENTI_STATI_TIPI_ERROR = 'pazienti_stati_tipi_error'

//redux: USERS_AUTORIZZATI
export const USERS_VALUE = 'users'
export const USERS_LOADED = 'users_loaded'
export const USERS_ERROR = 'users_error'

//redux: COMPANY
export const COMPANY_VALUE = 'companies'
export const COMPANY_LOADED = 'companies_loaded'
export const COMPANY_ERROR = 'companies_error'


//redux: MAGAZZINO
export const CURRENT_COMPANY_PRODOTTI = 'CURRENT_COMPANY_PRODOTTI';
export const CURRENT_COMPANY_LOTS = 'CURRENT_COMPANY_LOTS';
export const CURRENT_COMPANY_MAGAZZINI = 'CURRENT_COMPANY_MAGAZZINI';
export const CURRENT_COMPANY_SUPPLIERS = 'CURRENT_COMPANY_SUPPLIERS';
